module.exports = __webpack_public_path__ + "img/profile.6a4f2036.svg";